import type { AnyAbility } from '@casl/ability';
import { createContext } from 'react';

/**
 * The hydrated CASL ability plus whether rules are still loading. Typed as
 * `AnyAbility` to keep the context app-agnostic; `isLoading` distinguishes
 * "not fetched yet" (deny-all) from "fetched, genuinely no rules".
 */
export interface AccessControlContextValue {
  ability: AnyAbility;
  isLoading: boolean;
}

export const AccessControlContext = createContext<AccessControlContextValue | null>(null);
